import React, { Component } from "react"
import PropTypes from "prop-types"
import styles from "./LoadingPlaceholder.module.sass"

export default class LoadingPlaceholder extends Component {
  static propTypes = {
    height: PropTypes.number,
    loadingText: PropTypes.string,
    loader: PropTypes.object,
  }

  render() {
    return (
      <div
        className={`loading-container ${styles.loadingContainer}`}
        style={{ height: this.props.height }}
      >
        {this.props.loadingText ? (
          <p className={`loading-text ${styles.loadingText}`}>
            {this.props.loadingText}
          </p>
        ) : null}

        {this.props.loader || null}
      </div>
    )
  }
}
